import { useSearchParams } from 'react-router-dom';

const useCustomSearchParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const isDemo: boolean = !!searchParams.get('demo');
  const paymentId: string = searchParams.get('invoice') || '';
  const merchantInformation: string | null = searchParams.get('merchantInformation');
  const redirect: string | null = searchParams.get('redirect');
  const theme: string = searchParams.get('theme') || 'dark';
  const integrated: boolean = !!searchParams.get('integrated');
  const language: string = searchParams.get('lang') || '';
  const queryCurrency: string = searchParams.get('currency') || '';
  const queryNetwork: string = searchParams.get('network') || '';

  const parsedMerchantInformation = merchantInformation ? JSON.parse(merchantInformation) : null;

  const setQueryParam = (key: string, value: string) => {
    const currentParams = new URLSearchParams(searchParams);
    currentParams.set(key, value);

    setSearchParams(currentParams);
  };

  const setLanguage = (lang: string) => setQueryParam('lang', lang);

  return {
    isDemo,
    paymentId,
    parsedMerchantInformation,
    redirect,
    theme,
    integrated,
    language,
    queryCurrency,
    queryNetwork,
    setQueryParam,
    setLanguage,
  };
};

export { useCustomSearchParams };
